import React, { Component } from 'react';

import { Modal, Card } from 'react-bootstrap';

import CommonButton from './CommonButton';

import * as constants from '../../config/constants/AppConstants';

const UI_SIZE = constants.AppSettings.UI_SIZE;

class CommonPreviewFileModal extends Component {
  constructor(props) {
      super(props);
      this.state = {
        imageWidth: null,
        imageHeight: null,
      };
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props.Action.PreviewFile;
    const prevData = prevProps.Action.PreviewFile?.data;

    if (data !== prevData && data?.mimeType?.startsWith('image/')) {
      const img = new Image();
      img.onload = () => {
        this.setState({
          imageWidth: img.width,
          imageHeight: img.height
        });
      };
      img.src = data.blobUrl;
    }
  }

  getModalSize = () => {
    const { data } = this.props.Action.PreviewFile;
    const { imageWidth } = this.state;

    if (!data) return 'lg';

    if (data.mimeType?.startsWith('image/')) {
      if (imageWidth <= 400) return 'sm';
      if (imageWidth <= 768) return 'md';
      if (imageWidth <= 1200) return 'lg';
      return 'xl'; 
    }else{
      const { blobUrl, fileName, mimeType } = data;
      const isImage = mimeType?.startsWith('image/');
      const isPdf = mimeType === 'application/pdf';
      const isWord = mimeType === 'application/msword' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      const isExcel = mimeType === 'application/vnd.ms-excel' || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if( isExcel ){ return 'sm'; }
      if( isPdf || isWord ){ return 'xl';}
    }
    return 'xl';
  };

  renderContent = () => {
    const { data } = this.props.Action.PreviewFile;

    if (!data) return null;

    const { blobUrl, fileName, mimeType } = data;
    const isImage = mimeType?.startsWith('image/');
    const isPdf = mimeType === 'application/pdf';
    const isWord = mimeType === 'application/msword' || mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    const isExcel = mimeType === 'application/vnd.ms-excel' || mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (isImage) {
      return <img src={blobUrl} alt={fileName} className="img-fluid" />;
    }

    if (isPdf || isWord) {
      return (
        <iframe
          src={blobUrl}
          title={fileName}
          width="100%"
          height="500px"
          style={{ border: 'none' }}
        />
      );
    }

    if (isExcel) {
      return (
        <div className="text-center">
          <i className="fa fa-file-excel fa-2x text-dark mb-3" />
          <p className="mb-0 label-size-sm text-muted">ไม่สามารถแสดงตัวอย่างไฟล์ Excel ได้</p>
          <CommonButton
            task="download"
            callback={() => window.open(blobUrl, '_blank')}
            inlineClass="mt-3"
          />
        </div>
      );
    }

    return (
      <div className="text-center">
        <i className="fa fa-file fa-2x text-dark mb-3" />
        <p className="mb-0 label-size-sm text-muted">ไม่สามารถแสดงตัวอย่างไฟล์นี้ได้</p>
        <CommonButton
          task="download"
          callback={() => window.open(blobUrl, '_blank')}
          inlineClass="mt-3"
        />
      </div>
    );
  };

  render() {
    const { show, data } = this.props.Action.PreviewFile;
    const { onClose } = this.props;

    if (!show || !data) return null;

    return (
      <Modal show={show} size={this.getModalSize()} onHide={onClose} centered>
        <Modal.Header closeButton />      
        <Modal.Body>
            {this.renderContent()}
        </Modal.Body>
      </Modal>
    );
  }
}

export default CommonPreviewFileModal;
